var assert = require('assert');
module.exports = require('./int24.js')(assert);